import Vue from 'vue'
import App from './App.vue'
import axios from 'axios' //追記
import VueAxios from 'vue-axios' //追記
import '@babel/polyfill'


require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

new Vue({
  render: h => h(App)
}).$mount('#app')

